module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/zoom-icon.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/zoom-icon.eot
// module id = 385
// module chunks = 0